import {Component, computed, input} from '@angular/core';
import {formatPause} from '../pipes/format';

/** Dashed line with "Pauze 30 min" in the middle; computed from the gap between two registrations. */
@Component({
    selector: 'app-pause-divider',
    templateUrl: './pause-divider.component.html',
    styles: `
        :host {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 4px 0;
            font-size: 11px;
            color: #9aa0a6;
            white-space: nowrap;
        }

        .line {
            flex: 1;
            border-top: 1px dashed #d6d8db;
        }
    `,
    host: {
        'role': 'separator'
    }
})
export class PauseDividerComponent {
    readonly minutes = input.required<number>();
    readonly label = computed(() => formatPause(this.minutes()));
}
